export const getListTableSkeletonStyles = ({ customStyles }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '36px',

  ...customStyles,
});

export const tableBodySkeletonStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};

export const rowSkeletonStyles = {
  display: 'flex',
  justifyContent: 'space-between',
};
